import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { protectedResources } from '../auth/auth.config';
import { ProfileType } from '../models/user.model';

export interface ImpersonationHistoryEntry {
  time?: string;
  impersonator?: Partial<ProfileType>;
  impersonatedUser?: Partial<ProfileType>;
  justification?: string;
}

export interface ImpersonationHistoryDto {
  impersonations?: ImpersonationHistoryEntry[];
  /** Set only while a further page exists; passed back as {@code before}. */
  nextBefore?: string;
}

/** The masteradmin-only endpoints behind the impersonation tab. */
@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  private readonly apiEndpoint: string =
    protectedResources.apiTodoList.endpoint;

  constructor(private http: HttpClient) {}

  /** @param impersonatedUser the user to act as, named by e-mail address or id */
  start(impersonatedUser: string, justification: string) {
    return this.http.post<ProfileType>(
      `${this.apiEndpoint}/profile/impersonation`,
      { impersonatedUser, justification },
    );
  }

  stop() {
    return this.http.delete<ProfileType>(
      `${this.apiEndpoint}/profile/impersonation`,
    );
  }

  /** @param before the {@link ImpersonationHistoryDto.nextBefore} of the page before this one */
  history(limit: number, before?: string) {
    return this.http.get<ImpersonationHistoryDto>(
      `${this.apiEndpoint}/profile/impersonation/history`,
      { params: before ? { limit, before } : { limit } },
    );
  }
}
